import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, UserService } from '@core/services';

@Component({
    selector: 'app-update-billing-address',
    templateUrl: './update-billing-address.component.html',
    styleUrls: ['./update-billing-address.component.css']
})

export class UpdateBillingAddressComponent implements OnInit, OnDestroy {

    updateBillingAddress: FormGroup;
    private user: any;
    private subscription: Subscription;
    public errorMessage = '';

    constructor(private _fb: FormBuilder,
        private _userService: UserService,
        private _router: Router,
                private _authGuard: AuthGuardService,
                private dialog: MatDialog) {
    }

    ngOnInit() {
        this.updateBillingAddress = this._fb.group({
            billingAddress: this._fb.group({
                name: new FormControl('', Validators.required),
                Address: new FormControl('', Validators.required),
                City: new FormControl('', Validators.required),
                StateProvince: new FormControl('', Validators.required),
                ZipPostal: new FormControl('', [Validators.required, Validators.maxLength(10)]),
                phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(15)])
            })
        });
        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user;
            this.setBillingDefaults();
        });

        if (this.user.customerIdArray.length > 0) {
            this._authGuard.getAccountInfo();
        }

        this.setBillingDefaults();
    }

    ngOnDestroy() {

        this.subscription.unsubscribe();
    }

    onSubmit() {
        this.errorMessage = '';
        this.sendBillingAddressDataToServer();
    }

    private sendBillingAddressDataToServer() {
        const billingAddressData = this.setupBillingAddress();
        const insertBillingAddressEndpoint = 'portfolios/UpdateBilling';
        this._authGuard.authenticatedPost(insertBillingAddressEndpoint, billingAddressData).subscribe(
            result => {
              let updateBillingResult: any;
              updateBillingResult = result;

              this._userService.setBillingAddress(billingAddressData.name, billingAddressData.City, updateBillingResult.Country, billingAddressData.PrimaryTx,billingAddressData.ZipPostal,billingAddressData.StateProvince,billingAddressData.Address);
                let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                  message: 'You have successfully updated your billing address',
                  alertType: 'success',
                  title: 'Billing Address Updated'
              }
          });
           console.log('Success');
            },
            error => {
                console.log('billing error', error);
                this.errorMessage = error;
                let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                  message: 'Sorry we could not update your billing address, ' + error,
                  alertType: 'danger',
                  title: 'Failed to Update Billing Address'
              }
          });
            });
    }

    private setupBillingAddress() {
        const billingAddressData = this.updateBillingAddress.value.billingAddress;
        billingAddressData.CustomerId = this.getCustomerId();
        billingAddressData.NameOnCard = this.updateBillingAddress.value.billingAddress.name;
        billingAddressData.PrimaryTx = this.updateBillingAddress.value.billingAddress.phoneNumber;
        billingAddressData.UpdateUser = this.user.userName;
        return billingAddressData;
    }

    private getCustomerId() {
        return this.user.customerIdArray[this.user.customerIndex].Id;
    }

    private getCustomerName() {
        return this.user.userName;
    }

    public isSameAsMailing(event) {

        if (event.target.checked) {
            this.setMailingAddressToBillingAddress();
        } else {
            this.setBillingDefaults();
        }


    }

    private setMailingAddressToBillingAddress() {

        const currentMailingAddress = this.user.customerIdArray[this.user.customerIndex].MailingAddress;

        this.updateBillingAddress.controls.billingAddress.patchValue({
            Address: currentMailingAddress.Street,
            City: currentMailingAddress.City,
            StateProvince: currentMailingAddress.Province,
            ZipPostal: currentMailingAddress.PostalCode,
            phoneNumber: currentMailingAddress.Phone1,
        });
    }

    private clearBillingAddress() {
        this.updateBillingAddress.controls.billingAddress.reset();
    }

    private setBillingDefaults() {
        const currentBillingAddress = this.user.customerIdArray[this.user.customerIndex].BillingAddress;

        this.updateBillingAddress.controls.billingAddress.patchValue({
            name: currentBillingAddress.NameOnCard,
            Address: currentBillingAddress.Street,
            City: currentBillingAddress.City,
            StateProvince: currentBillingAddress.Province,
            ZipPostal: currentBillingAddress.PostalCode,
            phoneNumber: currentBillingAddress.Phone
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-billing-address/update-billing-address.component.ts